<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>公告詳情</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="content-info-person">
        公告人: {{ announcement.announcer }}
      </div>
      <div class="content-info-date">
        開始： {{ announcement.startAt }} ~ 結束： {{ announcement.endAt }}
      </div>
      <button class="btn btn-danger myButtonStyle" @click="onDeleteBtnClick">
        刪除
      </button>
    </div>
    <div class="row content">
      <div class="contentStyle" v-html="announcement.content"></div>
    </div>
  </div>
</template>
<script>
import API from '../../assets/js/libs/API'
import { cookies } from '@/utils/cookies'
import moment from 'moment'
import Announcement from '../../assets/js/libs/Announcement'

let announcement = new Announcement()
export default {
  name: 'BoardDetail',
  data() {
    return {
      id: this.$route.params.id,
      announcement: {
        announcer: '',
        startAt: '',
        endAt: '',
        content: '',
        isheadquarter: null,
      },
      manager: {
        name: '',
        teamCode: '',
      },
    }
  },
  mounted() {
    this.manager.name = cookies.get('GladName')
    this.manager.teamCode = cookies.get('GladTeamCode')
    API.get(`announcement/${this.id}`)
      .then((detail) => detail.data)
      .then((data) => {
        this.announcement.announcer = data.announcer
        this.announcement.subject = data.subject
        this.announcement.content = data.content
        this.announcement.startAt = moment(data.startAt).format(
          'YYYY-MM-DD HH:mm:ss',
        )
        this.announcement.endAt = moment(data.endAt).format(
          'YYYY-MM-DD HH:mm:ss',
        )
        this.announcement.isheadquarter = data.isheadquarter
      })
      .catch((err) => {
        console.error(err)
      })
  },
  methods: {
    onDeleteBtnClick() {
      if (confirm('確認刪除？')) {
        if (this.announcement.isheadquarter) {
          if (this.manager.teamCode === '000') {
            announcement
              .remove(this.id)
              .then((res) => {
                this.$router.replace('/serviceMain/board')
              })
              .catch((err) => {
                alert(err.data.message)
              })
          } else {
            alert('此為系統管理員訊息無法刪除')
          }
        } else {
          announcement
            .remove(this.id)
            .then((res) => {
              this.$router.replace('/serviceMain/board')
            })
            .catch((err) => {
              alert(err.data.message)
            })
        }
      }
    },
  },
}
</script>
<style scoped>
.content-info-person {
  display: inline-block;
  color: #404040;
  font-size: 18px;
}

.content-info-date {
  display: inline-block;
  margin-left: 100px;
  color: #ff4d4d;
  font-size: 18px;
}

.content {
  margin-top: 10px;
  border: solid 2px #e6f2ff;
  height: 500px;
  overflow: scroll;
}

.contentStyle {
  margin: 15px;
  font-size: 120%;
}

.myButtonStyle {
  float: right;
  font-size: 16px;
  padding: 5px 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/announcement/BoardDetail.vue